import { Suspense, type ReactNode } from 'react';
import { Loader } from '@/components/ui/Loader';
import { RouteLoadingContext } from './routeLoadingContext';

/** Keep an already-revealed page during lazy route transitions, not its spinner.
 * The shell keys this boundary by identity/workspace so prior authority never persists.
 */
export function RouteContentBoundary({ children }: { children: ReactNode }) {
  return <RouteLoadingContext.Provider value>
    <Suspense fallback={<div role="status" aria-label="Loading page" className="flex flex-1 items-center justify-center bg-app"><Loader /></div>}>
      {children}
    </Suspense>
  </RouteLoadingContext.Provider>;
}
